<div class="inner-block animate">
  <dot-loader [visibility]="!user"></dot-loader>
  <div class="row">
    <div class="col-sm-12">
      @if (user?.email) {
        <div class="account__card eq">
          <h2 class="margin--none">{{user.first_name}} {{user.last_name}}</h2>
          <div class="card__info">
            @if(!user.allowed_to_sign_in ) {
              <h3>Användaren är borttagen</h3>}
              <h3 class="text--medium">Email</h3>
              <p>{{user.email}}</p>
            @if(role.translatedName) {
              <h3 class="text--medium">Roll</h3>
              <p>{{role.translatedName}}</p>
            }
            @if (role.name === 'external_planner' || role.name === 'planner' || role.name === 'sales' || role.name === 'sales_manager') {
              <h3 class="text--medium">Organisation</h3>
              <p>{{user.ad_organisation.name}}</p>
            }
            @if (user.allowed_to_sign_in) {
              @if (hasAnyRole([UserRole.admin, UserRole.planner])) {
                <button class="link primary-1" (click)="toggleEdit()">Redigera</button>
              }
              @if (canManageUser()) {
                <button class="link secondary" (click)="resetPassword(user.id)">Återställ lösenord</button>
                <button class="link danger" (click)="deactivateUser(user)">Ta bort användare</button>
              }
            }
            @if (canReactivateAccount()) {
              <button class="link danger" (click)="reactivateUser(user)">Återaktivera användare</button>
            }
          </div>
        </div>
      }
    </div>
  </div>

  @if(role.name === 'client_user' || role.name === 'cash_user') {
    <div class="row">
      <div class="col-sm-12">
        <div class="tabbable__panel panel-padding clearfix shadow-z-1">
          <div class="col-sm-12">
            <h3>Kund</h3>
          </div>
        </div>
        <div class="account__card">
          @if (clientUserCustomer) {
            <h4>
              <a [routerLink]="['/customer', clientUserCustomer.id]">{{clientUserCustomer.name}}</a>
            </h4>
          }
          @if (cashUserCustomer) {
            <h4>
              <a [routerLink]="['/customer', cashUserCustomer.id]">{{cashUserCustomer.name}}</a>
            </h4>
          }
        </div>
      </div>
    </div>
  }

  @if (role.name === 'agency' && (hasAccountHandlingRole() || isAgencyAdmin(currentUser))) {
    <div class="row">
      <div class="col-sm-12">
        <div class="tabbable__panel panel-padding clearfix shadow-z-1">
          <div class="col-sm-12">
            <h3>Redigera kundtillhörighet</h3>
          </div>
        </div>
        <div class="account__card">
          <edit-user-customer-access [user]="user" (refresh)="refresh()"></edit-user-customer-access>
        </div>
      </div>
    </div>
  }
  <div #editUserSection class="row">
    <div class="col-sm-12">
      @if (editUser) {
        <div class="account__card">
          <div class="card__cover"></div>
          <user-form (afterSubmit)="userUpdated()" (onAbort)="toggleEdit()" [user]="user"></user-form>
        </div>
      }
    </div>
  </div>
</div>
